import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import "./footer.scss"
import { graphql, Link, useStaticQuery } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"
import RogersNewBrand from "./logo-ERbrand.svg"
import DeepInto from "./feel-mauritian-landscape.png"
import GreenKey from "./greenKey.png"
import HTMLReactParser from "html-react-parser"
import StyledButton from "../common/styledButton"
import { generateUrlForStaticPages } from "../../services/intl.service"
import CustomLink from "../common/customLink"
import { useCallback } from "react"
import HotelFlightLink from "../common/hotelFlightLink"

const FooterContainer = ({ pageContext, locale }) => {
  const intl = useIntl()

  const data = useStaticQuery(graphql`
    query FooterMenuQuery {
      footerMenuEn: allMenuLinkContentFooter(
        filter: { enabled: { eq: true }, title: { ne: "Dummy" }, langcode: { eq: "en" } }
        sort: { fields: weight }
      ) {
        ...footerMenuFields
      }
      footerMenuFr: allMenuLinkContentFooter(
        filter: { enabled: { eq: true }, title: { ne: "Dummy" }, langcode: { eq: "fr" } }
        sort: { fields: weight }
      ) {
        ...footerMenuFields
      }
      footerLeftContentEn: blockContentBlockFooterLeft(langcode: { eq: "en" }) {
        ...blockContentBlockFooterLeftFields
      }
      footerLeftContentFr: blockContentBlockFooterLeft(langcode: { eq: "fr" }) {
        ...blockContentBlockFooterLeftFields
      }
      upperFooterMenuEn: allMenuLinkContentUpperFooter(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "en" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...upperFooterMenuFields
      }
      upperFooterMenuFr: allMenuLinkContentUpperFooter(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "fr" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...upperFooterMenuFields
      }
    }
  `)

  let footerLeft, footerMenu, upperFooterMenu

  // Get footer data by locale
  switch (locale) {
    case "fr":
      if (data.footerLeftContentFr) {
        footerLeft = data.footerLeftContentFr
      }

      if (data.footerMenuFr && data.footerMenuFr.nodes) {
        footerMenu = data.footerMenuFr.nodes
      }
      if (data.footerLeftContentFr) {
        footerLeft = data.footerLeftContentFr
      }
      if (data.upperFooterMenuFr && data.upperFooterMenuFr.nodes) {
        upperFooterMenu = data.upperFooterMenuFr.nodes
      }
      break
    default:
      if (data.footerLeftContentEn) {
        footerLeft = data.footerLeftContentEn
      }
      if (data.footerMenuEn && data.footerMenuEn.nodes) {
        footerMenu = data.footerMenuEn.nodes
      }
      if (data.footerLeftContentEn) {
        footerLeft = data.footerLeftContentEn
      }
      if (data.upperFooterMenuEn && data.upperFooterMenuEn.nodes) {
        upperFooterMenu = data.upperFooterMenuEn.nodes
      }
  }

  // Create nested array for footer menus
  const hashTable = Object.create(null)
  footerMenu.forEach(
    menu => (hashTable[menu.drupal_id] = { ...menu, childNodes: [] })
  )

  const menuTree = []
  footerMenu.forEach(menu => {
    if (menu.drupal_parent_menu_item) {
      const stripped_drupal_id = menu.drupal_parent_menu_item.replace(
        "menu_link_content:",
        ""
      )
      hashTable[stripped_drupal_id]?.childNodes?.push(hashTable[menu.drupal_id])
    } else {
      menuTree.push(hashTable[menu.drupal_id])
    }
  })

  const scrollUp = useCallback(e => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }, 500)
  }, [])

  const toggleAccordion = e => {
    e.currentTarget.classList.toggle("active")
    var panel = e.currentTarget.nextElementSibling
    if (panel.style.display === "block") {
      panel.style.display = "none"
    } else {
      panel.style.display = "block"
    }
  }

  return (
    <section className="footer pt-100 pb-100">
      <Container>
        <div className="btn-foot">
          {upperFooterMenu.length > 0 &&
              upperFooterMenu.map((menu, index) => {
                return (
                  <StyledButton
                    type="transparent"
                    title={menu.title}
                    key={index}
                    path={generateUrlForStaticPages(
                      menu.langcode,
                      menu.link.url
                    )}
                  />
                )
              })
          }
          <HotelFlightLink
              locale={locale}
          />
        </div>
        <button className="arrow" onClick={scrollUp}>
          <i className="icon-up"></i>
        </button>
        <Row className="menuList blk-spacing">
          <Col md={3} xs={12} >
            <h2>Contact</h2>
            <div className="contact">
              <div className="vcard">
                <div className="adr">
                  {HTMLReactParser(
                    footerLeft.block_footer_left_text.processed
                  )}
                  <a href="javascript:linkTo_UnCryptMailto('nbjmup;cppljohAwfsboeb.sftpsut/dpn');">booking@veranda-resorts.com</a>
                </div>
              </div>
            </div>
            <div className="icon">
              <ul>
                <li>
                  <a aria-label="Twitter" href="https://twitter.com/verandaresorts" target="_blank">
                    <i className="icon-twitter"></i>
                  </a>
                </li>
                <li>
                  <a aria-label="Facebook" href="https://www.facebook.com/verandaresorts" target="_blank">
                    <i className="icon-facebook"></i>
                  </a>
                </li>
                <li>
                  <a aria-label="Pinterest" href="http://pinterest.com/verandaresorts?_ga=2.135350257.1303884507.1666151476-870728950.1666151476" target="_blank">
                    <i className="icon-pinterest"></i>
                  </a>
                </li>
                <li>
                  <a aria-label="Instagram" href="https://www.instagram.com/verandaresorts/?_ga=2.157344634.1303884507.1666151476-870728950.1666151476">
                    <i className="icon-instagram"></i>
                  </a>
                </li>
                <li>
                  <a aria-label="Youtube" href="https://www.youtube.com/verandaresorts?_ga=2.135350257.1303884507.1666151476-870728950.1666151476" target="_blank">
                    <i className="icon-youtube"></i>
                  </a>
                </li>
              </ul>
            </div>
          </Col>
          <Col md={7} xs={12}>
            {menuTree.length &&
              menuTree.map(menu => {
                return (
                  <div>
                    <h2 onClick={toggleAccordion} className="js-toggle-mob">{menu.title}</h2>
                    <ul>
                      {menu.childNodes.map(child => {
                          return (
                            <li key={child.drupal_id}>
                              <CustomLink
                                path={generateUrlForStaticPages(
                                  child.langcode,
                                  child.link.url
                                )}
                                title={child.title}
                              />
                            </li>
                          )
                        })}
                    </ul>
                  </div>
                )
              })}
          </Col>
          <Col md={2} xs={12} >
            <h2>{intl.formatMessage({ id: "footer.tagline" })}</h2>
            <div className="imgCont">
              <div className="imageDeepInto">
                {
                  locale === "en" ? (
                      <a className="link" href="/en/mauritius-hotels/experiences">
                        <img src={DeepInto} width="170" height="41" alt="DeepIntoMauritius" />
                      </a>
                  ) : (
                      <a className="link" href="/hotels-ile-maurice/experiences">
                        <img src={DeepInto} width="170" height="41" alt="DeepIntoMauritius" />
                      </a>
                  )
                }
              </div>
              <div className="imageGreenKey">
                <img src={GreenKey} width="56" height="70" alt="GreenKey" />
              </div>
            </div>
          </Col>
        </Row>
        <Row className="footerLinks pt-25 pb-25">
          <Col md={7} xs={12} className="listLogo">
            <a href="https://rogershospitality.com/" target="_blank">
              <img src={RogersNewBrand} alt="Rogers Hospitality Brand" width="180" />
            </a>
          </Col>
          <Col md={5} xs={12}>
            <div>
              <p>
                Copyright© {new Date().getFullYear()} {intl.formatMessage({ id: "copyright.title" })}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default FooterContainer
